import { Backdrop } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GENERAL__CLOSE, WAGE_INDEXATION__PERFORMED } from 'translations/constants';
import { ModalActionButton, ModalActionContainer, ModalContainer, ModalTitle, WageIndexationModal } from './styles';

const SuccessIndexationModal = ({ isOpen, onClose }) => {
  const [t] = useTranslation();

  return (
    <Backdrop open={isOpen} sx={{ zIndex: '2000' }}>
      <WageIndexationModal open={isOpen} onClose={onClose}>
        <ModalContainer>
          <ModalTitle>{t(WAGE_INDEXATION__PERFORMED)}</ModalTitle>
          <ModalActionContainer>
            <ModalActionButton text={t(GENERAL__CLOSE)} onClick={onClose} />
          </ModalActionContainer>
        </ModalContainer>
      </WageIndexationModal>
    </Backdrop>
  );
};

export default SuccessIndexationModal;
